import React from "react";
import {toast} from "react-toastify";
import {toastSuccess, toastWarning} from "../../../utils/toast";
import {cleanupLinkage, LINK} from "./storeLinkage";

const cleanupFailedMessage = (linkageType, args, cleanupError) => <>
    {`${args.sourceStoreId} was ${linkageType === LINK ? 'linked' : 'unlinked'}, but clearing its old linkage rows failed: ${cleanupError.message}`}
    <button type={"button"} className={"button"} data-testid={"retry-linkage-cleanup"}
            onClick={() => cleanupLinkageWithRetry(linkageType, args, true)}>
        Retry cleanup
    </button>
</>;

const cleanupLinkageWithRetry = (linkageType, args, isRetry = false) =>
    cleanupLinkage(linkageType, args)
        .then(() => {
            if (isRetry) toastSuccess(toast, `Cleared the old linkage rows for ${args.sourceStoreId}`);
        })
        .catch(cleanupError => toastWarning(toast, cleanupFailedMessage(linkageType, args, cleanupError)));

export default cleanupLinkageWithRetry;
